import { default as career_45questionnaireuZ4Pl8ntloMeta } from "/app/pages/career-questionnaire.vue?macro=true";
import { default as indexhggf4xRU4hMeta } from "/app/pages/company/[slug]/index.vue?macro=true";
import { default as jobIoPTi2mchsMeta } from "/app/pages/company/[slug]/job.vue?macro=true";
import { default as additional_45infoR6wfJCG6iBMeta } from "/app/pages/complete-profile/additional-info.vue?macro=true";
import { default as educationREam4N93T9Meta } from "/app/pages/complete-profile/education.vue?macro=true";
import { default as experiencetQFqVFxakzMeta } from "/app/pages/complete-profile/experience.vue?macro=true";
import { default as future_45planaWI4qlcjUCMeta } from "/app/pages/complete-profile/future-plan.vue?macro=true";
import { default as index9hXTF6Ozz4Meta } from "/app/pages/complete-profile/index.vue?macro=true";
import { default as personal_45infoiUdvtfUSTAMeta } from "/app/pages/complete-profile/personal-info.vue?macro=true";
import { default as future_45planXfvt1jPivSMeta } from "/app/pages/complete-profile/review/future-plan.vue?macro=true";
import { default as index0WUqEXzirXMeta } from "/app/pages/complete-profile/review/index.vue?macro=true";
import { default as reviewsstessgxHkHESVRyMeta } from "/app/pages/complete-profile/reviewsstess.vue?macro=true";
import { default as dashboardJu37u7k0toMeta } from "/app/pages/dashboard.vue?macro=true";
import { default as forgot_45password1UbT4qDpFeMeta } from "/app/pages/forgot-password.vue?macro=true";
import { default as help_45centergakdipake4IPi6oJ7X4Meta } from "/app/pages/help-centergakdipake.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as index8ufXmiLFDDMeta } from "/app/pages/job/[slug]/index.vue?macro=true";
import { default as index09mC9X8AMFMeta } from "/app/pages/job/index.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as _91tab_934WzeipX1EqMeta } from "/app/pages/my-job/[tab].vue?macro=true";
import { default as indexkU6JjqmuqmMeta } from "/app/pages/notification/index.vue?macro=true";
import { default as privacy_45policyOPxqa3IsSYMeta } from "/app/pages/privacy-policy.vue?macro=true";
import { default as change_45passwordo2vgATcAzzMeta } from "/app/pages/profile/change-password.vue?macro=true";
import { default as generated_45resume38mVsI6VybMeta } from "/app/pages/profile/generated-resume.vue?macro=true";
import { default as indexaeouN7Kzh7Meta } from "/app/pages/profile/index.vue?macro=true";
import { default as registermu8R7rSP5uMeta } from "/app/pages/register.vue?macro=true";
import { default as terms_45conditionsRRu4oncQRtMeta } from "/app/pages/terms-conditions.vue?macro=true";
import { default as verify_45accountiXEASbDJ5HMeta } from "/app/pages/verify-account.vue?macro=true";
import { default as verify_45newsletterHzzcFtxdmlMeta } from "/app/pages/verify-newsletter.vue?macro=true";
export default [
  {
    name: career_45questionnaireuZ4Pl8ntloMeta?.name ?? "career-questionnaire",
    path: career_45questionnaireuZ4Pl8ntloMeta?.path ?? "/career-questionnaire",
    meta: career_45questionnaireuZ4Pl8ntloMeta || {},
    alias: career_45questionnaireuZ4Pl8ntloMeta?.alias || [],
    redirect: career_45questionnaireuZ4Pl8ntloMeta?.redirect || undefined,
    component: () => import("/app/pages/career-questionnaire.vue").then(m => m.default || m)
  },
  {
    name: indexhggf4xRU4hMeta?.name ?? "company-slug",
    path: indexhggf4xRU4hMeta?.path ?? "/company/:slug()",
    meta: indexhggf4xRU4hMeta || {},
    alias: indexhggf4xRU4hMeta?.alias || [],
    redirect: indexhggf4xRU4hMeta?.redirect || undefined,
    component: () => import("/app/pages/company/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: jobIoPTi2mchsMeta?.name ?? "company-slug-job",
    path: jobIoPTi2mchsMeta?.path ?? "/company/:slug()/job",
    meta: jobIoPTi2mchsMeta || {},
    alias: jobIoPTi2mchsMeta?.alias || [],
    redirect: jobIoPTi2mchsMeta?.redirect || undefined,
    component: () => import("/app/pages/company/[slug]/job.vue").then(m => m.default || m)
  },
  {
    name: additional_45infoR6wfJCG6iBMeta?.name ?? "complete-profile-additional-info",
    path: additional_45infoR6wfJCG6iBMeta?.path ?? "/complete-profile/additional-info",
    meta: additional_45infoR6wfJCG6iBMeta || {},
    alias: additional_45infoR6wfJCG6iBMeta?.alias || [],
    redirect: additional_45infoR6wfJCG6iBMeta?.redirect || undefined,
    component: () => import("/app/pages/complete-profile/additional-info.vue").then(m => m.default || m)
  },
  {
    name: educationREam4N93T9Meta?.name ?? "complete-profile-education",
    path: educationREam4N93T9Meta?.path ?? "/complete-profile/education",
    meta: educationREam4N93T9Meta || {},
    alias: educationREam4N93T9Meta?.alias || [],
    redirect: educationREam4N93T9Meta?.redirect || undefined,
    component: () => import("/app/pages/complete-profile/education.vue").then(m => m.default || m)
  },
  {
    name: experiencetQFqVFxakzMeta?.name ?? "complete-profile-experience",
    path: experiencetQFqVFxakzMeta?.path ?? "/complete-profile/experience",
    meta: experiencetQFqVFxakzMeta || {},
    alias: experiencetQFqVFxakzMeta?.alias || [],
    redirect: experiencetQFqVFxakzMeta?.redirect || undefined,
    component: () => import("/app/pages/complete-profile/experience.vue").then(m => m.default || m)
  },
  {
    name: future_45planaWI4qlcjUCMeta?.name ?? "complete-profile-future-plan",
    path: future_45planaWI4qlcjUCMeta?.path ?? "/complete-profile/future-plan",
    meta: future_45planaWI4qlcjUCMeta || {},
    alias: future_45planaWI4qlcjUCMeta?.alias || [],
    redirect: future_45planaWI4qlcjUCMeta?.redirect || undefined,
    component: () => import("/app/pages/complete-profile/future-plan.vue").then(m => m.default || m)
  },
  {
    name: index9hXTF6Ozz4Meta?.name ?? "complete-profile",
    path: index9hXTF6Ozz4Meta?.path ?? "/complete-profile",
    meta: index9hXTF6Ozz4Meta || {},
    alias: index9hXTF6Ozz4Meta?.alias || [],
    redirect: index9hXTF6Ozz4Meta?.redirect || undefined,
    component: () => import("/app/pages/complete-profile/index.vue").then(m => m.default || m)
  },
  {
    name: personal_45infoiUdvtfUSTAMeta?.name ?? "complete-profile-personal-info",
    path: personal_45infoiUdvtfUSTAMeta?.path ?? "/complete-profile/personal-info",
    meta: personal_45infoiUdvtfUSTAMeta || {},
    alias: personal_45infoiUdvtfUSTAMeta?.alias || [],
    redirect: personal_45infoiUdvtfUSTAMeta?.redirect || undefined,
    component: () => import("/app/pages/complete-profile/personal-info.vue").then(m => m.default || m)
  },
  {
    name: future_45planXfvt1jPivSMeta?.name ?? "complete-profile-review-future-plan",
    path: future_45planXfvt1jPivSMeta?.path ?? "/complete-profile/review/future-plan",
    meta: future_45planXfvt1jPivSMeta || {},
    alias: future_45planXfvt1jPivSMeta?.alias || [],
    redirect: future_45planXfvt1jPivSMeta?.redirect || undefined,
    component: () => import("/app/pages/complete-profile/review/future-plan.vue").then(m => m.default || m)
  },
  {
    name: index0WUqEXzirXMeta?.name ?? "complete-profile-review",
    path: index0WUqEXzirXMeta?.path ?? "/complete-profile/review",
    meta: index0WUqEXzirXMeta || {},
    alias: index0WUqEXzirXMeta?.alias || [],
    redirect: index0WUqEXzirXMeta?.redirect || undefined,
    component: () => import("/app/pages/complete-profile/review/index.vue").then(m => m.default || m)
  },
  {
    name: reviewsstessgxHkHESVRyMeta?.name ?? "complete-profile-reviewsstess",
    path: reviewsstessgxHkHESVRyMeta?.path ?? "/complete-profile/reviewsstess",
    meta: reviewsstessgxHkHESVRyMeta || {},
    alias: reviewsstessgxHkHESVRyMeta?.alias || [],
    redirect: reviewsstessgxHkHESVRyMeta?.redirect || undefined,
    component: () => import("/app/pages/complete-profile/reviewsstess.vue").then(m => m.default || m)
  },
  {
    name: dashboardJu37u7k0toMeta?.name ?? "dashboard",
    path: dashboardJu37u7k0toMeta?.path ?? "/dashboard",
    meta: dashboardJu37u7k0toMeta || {},
    alias: dashboardJu37u7k0toMeta?.alias || [],
    redirect: dashboardJu37u7k0toMeta?.redirect || undefined,
    component: () => import("/app/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: forgot_45password1UbT4qDpFeMeta?.name ?? "forgot-password",
    path: forgot_45password1UbT4qDpFeMeta?.path ?? "/forgot-password",
    meta: forgot_45password1UbT4qDpFeMeta || {},
    alias: forgot_45password1UbT4qDpFeMeta?.alias || [],
    redirect: forgot_45password1UbT4qDpFeMeta?.redirect || undefined,
    component: () => import("/app/pages/forgot-password.vue").then(m => m.default || m)
  },
  {
    name: help_45centergakdipake4IPi6oJ7X4Meta?.name ?? "help-centergakdipake",
    path: help_45centergakdipake4IPi6oJ7X4Meta?.path ?? "/help-centergakdipake",
    meta: help_45centergakdipake4IPi6oJ7X4Meta || {},
    alias: help_45centergakdipake4IPi6oJ7X4Meta?.alias || [],
    redirect: help_45centergakdipake4IPi6oJ7X4Meta?.redirect || undefined,
    component: () => import("/app/pages/help-centergakdipake.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect || undefined,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index8ufXmiLFDDMeta?.name ?? "job-slug",
    path: index8ufXmiLFDDMeta?.path ?? "/job/:slug()",
    meta: index8ufXmiLFDDMeta || {},
    alias: index8ufXmiLFDDMeta?.alias || [],
    redirect: index8ufXmiLFDDMeta?.redirect || undefined,
    component: () => import("/app/pages/job/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: index09mC9X8AMFMeta?.name ?? "job",
    path: index09mC9X8AMFMeta?.path ?? "/job",
    meta: index09mC9X8AMFMeta || {},
    alias: index09mC9X8AMFMeta?.alias || [],
    redirect: index09mC9X8AMFMeta?.redirect || undefined,
    component: () => import("/app/pages/job/index.vue").then(m => m.default || m)
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login",
    path: loginhHM0vSTW5jMeta?.path ?? "/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect || undefined,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: _91tab_934WzeipX1EqMeta?.name ?? "my-job-tab",
    path: _91tab_934WzeipX1EqMeta?.path ?? "/my-job/:tab()",
    meta: _91tab_934WzeipX1EqMeta || {},
    alias: _91tab_934WzeipX1EqMeta?.alias || [],
    redirect: _91tab_934WzeipX1EqMeta?.redirect || undefined,
    component: () => import("/app/pages/my-job/[tab].vue").then(m => m.default || m)
  },
  {
    name: indexkU6JjqmuqmMeta?.name ?? "notification",
    path: indexkU6JjqmuqmMeta?.path ?? "/notification",
    meta: indexkU6JjqmuqmMeta || {},
    alias: indexkU6JjqmuqmMeta?.alias || [],
    redirect: indexkU6JjqmuqmMeta?.redirect || undefined,
    component: () => import("/app/pages/notification/index.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyOPxqa3IsSYMeta?.name ?? "privacy-policy",
    path: privacy_45policyOPxqa3IsSYMeta?.path ?? "/privacy-policy",
    meta: privacy_45policyOPxqa3IsSYMeta || {},
    alias: privacy_45policyOPxqa3IsSYMeta?.alias || [],
    redirect: privacy_45policyOPxqa3IsSYMeta?.redirect || undefined,
    component: () => import("/app/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: change_45passwordo2vgATcAzzMeta?.name ?? "profile-change-password",
    path: change_45passwordo2vgATcAzzMeta?.path ?? "/profile/change-password",
    meta: change_45passwordo2vgATcAzzMeta || {},
    alias: change_45passwordo2vgATcAzzMeta?.alias || [],
    redirect: change_45passwordo2vgATcAzzMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/change-password.vue").then(m => m.default || m)
  },
  {
    name: generated_45resume38mVsI6VybMeta?.name ?? "profile-generated-resume",
    path: generated_45resume38mVsI6VybMeta?.path ?? "/profile/generated-resume",
    meta: generated_45resume38mVsI6VybMeta || {},
    alias: generated_45resume38mVsI6VybMeta?.alias || [],
    redirect: generated_45resume38mVsI6VybMeta?.redirect || undefined,
    component: () => import("/app/pages/profile/generated-resume.vue").then(m => m.default || m)
  },
  {
    name: indexaeouN7Kzh7Meta?.name ?? "profile",
    path: indexaeouN7Kzh7Meta?.path ?? "/profile",
    meta: indexaeouN7Kzh7Meta || {},
    alias: indexaeouN7Kzh7Meta?.alias || [],
    redirect: indexaeouN7Kzh7Meta?.redirect || undefined,
    component: () => import("/app/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: registermu8R7rSP5uMeta?.name ?? "register",
    path: registermu8R7rSP5uMeta?.path ?? "/register",
    meta: registermu8R7rSP5uMeta || {},
    alias: registermu8R7rSP5uMeta?.alias || [],
    redirect: registermu8R7rSP5uMeta?.redirect || undefined,
    component: () => import("/app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: terms_45conditionsRRu4oncQRtMeta?.name ?? "terms-conditions",
    path: terms_45conditionsRRu4oncQRtMeta?.path ?? "/terms-conditions",
    meta: terms_45conditionsRRu4oncQRtMeta || {},
    alias: terms_45conditionsRRu4oncQRtMeta?.alias || [],
    redirect: terms_45conditionsRRu4oncQRtMeta?.redirect || undefined,
    component: () => import("/app/pages/terms-conditions.vue").then(m => m.default || m)
  },
  {
    name: verify_45accountiXEASbDJ5HMeta?.name ?? "verify-account",
    path: verify_45accountiXEASbDJ5HMeta?.path ?? "/verify-account",
    meta: verify_45accountiXEASbDJ5HMeta || {},
    alias: verify_45accountiXEASbDJ5HMeta?.alias || [],
    redirect: verify_45accountiXEASbDJ5HMeta?.redirect || undefined,
    component: () => import("/app/pages/verify-account.vue").then(m => m.default || m)
  },
  {
    name: verify_45newsletterHzzcFtxdmlMeta?.name ?? "verify-newsletter",
    path: verify_45newsletterHzzcFtxdmlMeta?.path ?? "/verify-newsletter",
    meta: verify_45newsletterHzzcFtxdmlMeta || {},
    alias: verify_45newsletterHzzcFtxdmlMeta?.alias || [],
    redirect: verify_45newsletterHzzcFtxdmlMeta?.redirect || undefined,
    component: () => import("/app/pages/verify-newsletter.vue").then(m => m.default || m)
  }
]